export const MS_PRESET_EXTENSION = '.mspr';

export interface MotorSynthPresets {
    banks: Bank[];
}

/**
 * Map of string UUID (matches uniqueId) to preset contents
 */
export type PresetContents = { [key: string]: string };

export interface Bank {
    name: string;
    uniqueId: string;
    // undefined are empty slots
    presets: (Preset | undefined)[];
}

export interface Preset {
    name: string;
    uniqueId: string;
}